import { useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";

/**
 * Wrapper for class components to provide router utilities as props
 *    since only function components support React Router 6's new hooks.
 *
 * Please note: This is ONLY required for class components.
 *    Functional components can use the hooks directly.
 *
 * @param {} Component - A class-based component
 * @returns A function component that has access to React Router 6's hooks
 *
 * @example
 * // Define your class component as usual
 * class HelloWorld extends React.Component {
 *   render () {
 *     return <h1>Hello World</h1>
 *   }
 * }
 * // Wrap your class component with withRouter()
 * export default withRouter(Login);
 *
 */

export function withRouter(Component) {
	function ComponentWithRouterProp(props) {
		const location = useLocation();
		const navigate = useNavigate();
		const params = useParams();
		const [searchParams] = useSearchParams();
		const queryString = Object.fromEntries([...searchParams]);
		return <Component {...props} router={{ location, navigate, params, queryString }} />;
	}
	return ComponentWithRouterProp;
}
